import { useState, useMemo } from 'react'

/**
 * Simple toggle hook.
 */
export function useToggle(initial = false) {
  const [isEnabled, setEnabled] = useState(initial)
  return useMemo(
    () => ({
      isEnabled,
      set: setEnabled,
      toggle: () => {
        setEnabled((v) => !v)
      },
      enable: () => {
        setEnabled(true)
      },
      disable: () => {
        setEnabled(false)
      },
    }),
    [isEnabled],
  )
}
